/**
 * "Complete your registration" — a slim line under the title of My raves and
 * Find a rave, and the way to the optional `/complete` page.
 *
 * The user, 2026-10-20: "After that the user gains access straight to the
 * Find a rave page. Don't let the user go first into complete registration.
 * Only show a sub-banner suggesting to complete registration, until
 * completed." Their answers to the follow-ups: ALWAYS shown — no close
 * button — on both pages, and gone once the registration is complete.
 *
 * It reads the gate's own answer (`useCompletion()` in `CompleteAccount.tsx`):
 * shown only to somebody signed in whose answer says `finished: false`, and
 * never while the check is waiting, failed or offline — a suggestion nobody
 * could act on without a signal is noise in a field.
 */
import { useNavigate } from 'react-router-dom';
import { Button } from '@/ui';
import { useT } from '@/i18n';
import { useAuth } from './AuthProvider';
import { useCompletion } from './CompleteAccount';
import './CompleteProfileBanner.css';

export function CompleteProfileBanner() {
  const tr = useT();
  const navigate = useNavigate();
  const { user } = useAuth();
  const { status, state } = useCompletion();
  if (!user || status !== 'ready' || !state || state.finished) return null;

  return (
    <aside className="complete-profile-banner" aria-label={tr('Complete your registration')}>
      <div className="complete-profile-banner-text">
        <strong className="complete-profile-banner-title">{tr('Complete your registration')}</strong>
        <span className="complete-profile-banner-line">
          {tr('Add your phone, link your other accounts and tell ravers about you — all optional.')}
        </span>
      </div>
      <Button variant="secondary" onClick={() => navigate('/complete')}>{tr('Complete my profile')}</Button>
    </aside>
  );
}
